export default {
  title: 'Do you want to delete this image?',
  text: 'This operation can not be reverted and the image will be deleted forever.',
  deny: 'Keep the image',
  confirm: 'Delete the image',
};
